import axiosInstance from "./axiosConfig"

export const getAllPlans = async () => {
   return await axiosInstance.get('/packages');
}

export const getAllInvoice = async () => {
   return await axiosInstance.get('/invoices');
}

export const getInvoiceById = async (id) => {
   return await axiosInstance.get(`/invoices/${id}`)
}

export const getAllPaymentMethods = async () => {
   return await axiosInstance.get('/payment_methods');
}

export const getPaymentCardInfo = async () => {
   return await axiosInstance.get('/subscriptions/card_info');
}

export const applyCoupon = async (data) => {
   return await axiosInstance.post('/subscriptions/check_coupon', data, { silent: true });
}

export const removeCoupon = async (data) => {
   return await axiosInstance.delete('/subscriptions/remove_coupon', data, { silent: true });
}

export const getCurrentPlan = async () => {
   return await axiosInstance.get('/packages/current_plan_details')
}

export const getNextBilling = async () => {
   return await axiosInstance.get(`/subscriptions/next_billing`)
}

export const upgradePlan = async (data) => {
   return await axiosInstance.post(`/subscriptions/upgrade`, data)
}

export const downgradePlan = async (data) => {
   return await axiosInstance.post(`/subscriptions/downgrade`, data)
}

export const addPaymentMethod = async (data) => {
   return await axiosInstance.post('/payment_methods', data)
}

export const updatePaymentMethod = async (methodId) => {
   return await axiosInstance.patch(`/payment_methods/${methodId}`, data)
}

export const deletePaymentMethod = async (methodId) => {
   return await axiosInstance.delete(`/payment_methods/${methodId}`)
}

export const cancelSubscription = async (data) => {
   return await axiosInstance.post(`/subscriptions/cancel`, data)
}

export const paymentStatus = async (invoiceId) => {
   return await axiosInstance.get(`/payments/${invoiceId}/status`)
}

export const createPlan = async (data) => {
   return await axiosInstance.post(`/packages`, data)
}

export const previewPlanSummary = async (data) => {
   return await axiosInstance.post('/subscriptions/invoice_preview', data)
}

export const addonInvoicePreview = async (marketplaceAccountId) => {
   let query = "";
   if (Array.isArray(marketplaceAccountId)) {
      query = marketplaceAccountId
         .map(id => `marketplace_account_id[]=${id}`)
         .join("&");
   }
   else {
      query = `marketplace_account_id=${marketplaceAccountId}`;
   }

   return await axiosInstance.get(`/subscriptions/addon_invoice_preview?${query}`);
};


export const addonSellerAccount = async (marketplaceAccountId) => {
   const isArray = Array.isArray(marketplaceAccountId);

   let query = "";
   if (isArray) {
      query = marketplaceAccountId
         .map(id => `marketplace_account_ids[]=${id}`)
         .join("&");
   }
   else {
      query = `marketplace_account_id=${marketplaceAccountId}`;
   }
   return await axiosInstance.get(`/subscriptions/addon_account?${query}`)
};


export const paymentSessionExpired = async (data) => {
   return await axiosInstance.post('payments/time_expired', data)
}

export const reGeneratePaymentUrl = async (data) => {
   return await axiosInstance.get('/subscriptions/reapply_auth_link', {
      params: data
   })
}